import Vue from 'vue'
import Router from 'vue-router'
/* import Home from 'components/home/home'
import DeviceSee from 'components/deviceSee/deviceSee'
import AddEquipList from 'components/deviceSee/addEquipList'
import Register from 'components/register/register'
import AddCompany from 'components/addCompany/addCompany'
import Login from 'components/login/login'
import Password from 'components/register/password'
import EquipmentList from 'components/equipmentList/equipmentList'
import SelectWay from 'components/selectWay/selectWay'
import SureAdd from 'components/sureAdd/sureAdd'
import AllDevice from 'components/allDevice/allDevice'
import UndoneOrder from 'components/undoneOrder/undoneOrder'
import UndoneHome from 'components/undoneOrder/undoneHome'
import UndoneDetail from 'components/undoneOrder/undoneDetail'
import SendCodeImg from 'components/sendCodeImg/sendCodeImg'
import GetCodeImg from 'components/sendCodeImg/getCodeImg'
import DeliveryInput from 'components/deliveryInput/deliveryInput'
import DeliveryEnd from 'components/deliveryInput/deliveryEnd'
import OrderHistory from 'components/orderHistory/orderHistory'
import OrderNoPay from 'components/orderHistory/orderNoPay'
import HistoryDetail from 'components/orderHistory/historyDetail'
import Download from 'components/orderHistory/download'
import NoPayDetail from 'components/orderHistory/noPayDetail'
import Apply from 'components/apply/apply'
import SendImg from 'components/sendImg/sendImg'
import Pay from 'components/sendImg/pay'
import MineInfo from 'components/mineInfo/mineInfo'
import CompanyInfo from 'components/addCompany/companyInfo' */
import {getCookie} from 'common/js/mUtils'

const Home = () => import('components/home/home')
const AddHome = () => import('components/home/addHome')
const DeviceSee = () => import('components/deviceSee/deviceSee')
const AddEquipList = () => import('components/deviceSee/addEquipList')
const Register = () => import('components/register/register')
const AddCompany = () => import('components/addCompany/addCompany')
const Login = () => import('components/login/login')
const Password = () => import('components/register/password')
const UpdatePassword = () => import('components/register/updatePassword')
const EquipmentList = () => import('components/equipmentList/equipmentList')
const SelectWay = () => import('components/selectWay/selectWay')
const SelectDetail = () => import('components/selectWay/selectDetail')
const SureAdd = () => import('components/sureAdd/sureAdd')
const AllDevice = () => import('components/allDevice/allDevice')
const SendPDF = () => import('components/sendPDF/sendPDF')
const AllSeePdf = () => import('components/allDevice/allSeePdf')
const UndoneOrder = () => import('components/undoneOrder/undoneOrder')
const UndoneHome = () => import('components/undoneOrder/undoneHome')
const UndoneDetail = () => import('components/undoneOrder/undoneDetail')
const SendCodeImg = () => import('components/sendCodeImg/sendCodeImg')
const GetCodeImg = () => import('components/sendCodeImg/getCodeImg')
const DeliveryInput = () => import('components/deliveryInput/deliveryInput')
const DeliveryEnd = () => import('components/deliveryInput/deliveryEnd')
const OrderHistory = () => import('components/orderHistory/orderHistory')
const OrderNoPay = () => import('components/orderHistory/orderNoPay')
const HistoryDetail = () => import('components/orderHistory/historyDetail')
const Download = () => import('components/orderHistory/download')
const NoPayDetail = () => import('components/orderHistory/noPayDetail')
const Apply = () => import('components/apply/apply')
const SendImg = () => import('components/sendImg/sendImg')
const Pay = () => import('components/sendImg/pay')
const MineInfo = () => import('components/mineInfo/mineInfo')
const CompanyInfo = () => import('components/addCompany/companyInfo')
const Company = () => import('components/company/company')

Vue.use(Router)

const routersList = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/addHome',
    name: 'addHome',
    component: AddHome
  },
  {
    path: '/company',
    name: 'company',
    component: Company
  },
  {
    path: '/deviceSee',
    name: 'deviceSee',
    component: DeviceSee
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/addCompany',
    name: 'addCompany',
    component: AddCompany
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/password',
    name: 'password',
    component: Password
  },
  {
    path: '/equipmentList',
    name: 'equipmentList',
    component: EquipmentList,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/allDevice',
    name: 'allDevice',
    component: AllDevice,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/allSeePdf/:deviceId',
    name: 'allSeePdf',
    component: AllSeePdf,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/sendPDF',
    name: 'sendPDF',
    component: SendPDF,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/addEquipList',
    name: 'addEquipList',
    component: AddEquipList,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/selectWay/:orderId',
    name: 'selectWay',
    component: SelectWay,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/selectDetail',
    name: 'selectDetail',
    component: SelectDetail,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/sureAdd/:orderId',
    name: 'sureAdd',
    component: SureAdd,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/undoneOrder',
    name: 'undoneOrder',
    component: UndoneOrder,
    meta: {
      requireAuth: true
    },
    redirect: '/undoneOrder/undoneHome',
    children: [
      {
        path: 'undoneHome',
        name: 'undoneHome',
        component: UndoneHome,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'undoneDetail/:orderId',
        name: 'undoneDetail',
        component: UndoneDetail,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'sendCodeImg/:orderId',
        name: 'sendCodeImg',
        component: SendCodeImg,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'getCodeImg/:orderId',
        name: 'getCodeImg',
        component: GetCodeImg,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'deliveryInput/:orderId',
        name: 'deliveryInput',
        component: DeliveryInput,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'deliveryEnd/:orderId',
        name: 'deliveryEnd',
        component: DeliveryEnd,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'orderHistory',
        name: 'orderHistory',
        component: OrderHistory,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'orderNoPay',
        name: 'orderNoPay',
        component: OrderNoPay,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'historyDetail/:orderId',
        name: 'historyDetail',
        component: HistoryDetail,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'download',
        name: 'download',
        component: Download,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'noPayDetail/:orderId',
        name: 'noPayDetail',
        component: NoPayDetail,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'apply',
        name: 'apply',
        component: Apply,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'sendImg',
        name: 'sendImg',
        component: SendImg,
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'pay',
        name: 'pay',
        component: Pay,
        meta: {
          requireAuth: true
        }
      }
    ]
  },
  {
    path: '/mineInfo',
    name: 'mineInfo',
    component: MineInfo,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/updatePassword',
    name: 'updatePassword',
    component: UpdatePassword
  },
  {
    path: '/companyInfo',
    name: 'companyInfo',
    component: CompanyInfo,
    meta: {
      requireAuth: true
    }
  }
]
const router = new Router({
  mode: 'hash',
  routes: routersList,
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    let token = getCookie('u_uuid_token')
    if (!token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js